var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"GenderAge"},[(_vm.male)?_c('Male',{attrs:{"age":_vm.age}}):_vm._e(),_vm._v(" "),(_vm.female)?_c('Female',{attrs:{"age":_vm.age}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }